export default __webpack_public_path__ + "static/logo-blk-19af5ceefaac349f4954bf76b84ba61a.webp";